@if (this.chequeRemittanceModel$ | async; as chequeRemittanceModel) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col">
          <table class="table table-striped border-bottom">
            <thead>
              <tr>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_CLIENT</a>
                </th>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_DATE</a>
                </th>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_REFERENCE</a>
                </th>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_AMOUNT</a>
                </th>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_STATUS</a>
                </th>
                <th>
                  <a translate>CHEQUE_REMITTANCE_LBL_ACTIONS</a>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (accountMove of chequeRemittanceModel.accountMoves; track accountMove.id) {
                <ng-container class="row-action">
                  @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                    <tr>
                      <td>
                        {{ accountMove.debitAccountName }}
                      </td>
                      <td>
                        {{ accountMoveLine.creationDate | toLocalTime : "dd/MM/yyyy" }}
                      </td>
                      <td>{{ accountMove.reference }}</td>
                      <td>{{ (accountMoveLine.unitPrice * accountMoveLine.quantity) | currency : "EUR" }}</td>
                      <td>{{ accountMove.statusLoc }}</td>
                      <td>
                        @for ( action of accountMove.actions; let last = $last; track action.actionName)
                          {
                          <a
                            role="button"
                          (click)="
                        this.triggerAction(
                          action.name,
                          accountMove.id,
                          chequeRemittanceModel.id
                        )
                      "
                            translate
                            >{{ action.actionName }}{{ last ? "" : " | " }}</a
                            >
                          }
                        </td>
                      </tr>
                    }
                  </ng-container>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
